import React from 'react';

import MappingRulesExplorer from '@components/detail-panel/components/EventMappingRules/MappingRulesExplorer';
import { IMappingRules } from '@components/detail-panel/components/EventMappingRules/typed';
import MappingRulesManagement from '@components/mapped-event-management/components/MappingRulesManagement';

const MappedRules: React.FC<IMappingRules> = ({
  readOnly,
  mode,
  mappedEvent,
  onChange,
  onClick,
}) => {
  return (
    <div>
      <MappingRulesExplorer
        readOnly={readOnly}
        mode={mode}
        title="Mapping Rules"
        buttonText="View in Semantic Mapper"
        onClick={onClick}
      />
      <MappingRulesManagement mode={mode} data={mappedEvent} onChange={onChange} />
    </div>
  );
};

export default MappedRules;
